import { render, staticRenderFns } from "./SupplyTerms.view.vue?vue&type=template&id=54d14046&"
import script from "./SupplyTerms.view.vue?vue&type=script&lang=js&"
export * from "./SupplyTerms.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d14046')) {
      api.createRecord('54d14046', component.options)
    } else {
      api.reload('54d14046', component.options)
    }
    module.hot.accept("./SupplyTerms.view.vue?vue&type=template&id=54d14046&", function () {
      api.rerender('54d14046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/contract/sign/partials/SupplyTerms.view.vue"
export default component.exports